import { api, apiEndPoints } from "../../api";
import { showSnackbar } from "../../components/snackbar/actions";
import { snackbarTypes } from "../../constants";

const namespace = "containers/faq";

export const SET_CATEGORY_LIST = `${namespace}/SET_CATEGORY_LIST`;
export const SET_FAQ_LIST = `${namespace}/SET_FAQ_LIST`;
export const SET_FAQ_FILTER = `${namespace}/SET_FAQ_FILTER`;
export const RESET_FAQ_FILTER = `${namespace}/RESET_FAQ_FILTER`;

const setCategoryList = (payload) => ({
  type: SET_CATEGORY_LIST,
  payload,
});

const setFaqList = (payload) => ({
  type: SET_FAQ_LIST,
  payload,
});

export const setFaqFilter = (payload) => ({
  type: SET_FAQ_FILTER,
  payload,
});

export const resetFaqFilter = () => ({
  type: RESET_FAQ_FILTER,
});

export const getCategoryList = (params) => async (dispatch) => {
  try {
    const response = await api.get(apiEndPoints.getCategories, {
      params: { params },
    });
    const { data, data: { is_success } = {} } = response;
    if (is_success) {
      dispatch(setCategoryList(data));
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const getFaqsList = (params) => async (dispatch) => {
  try {
    const response = await api.get(apiEndPoints.getFaqs, {
      params: { params },
    });
    const { data, data: { is_success } = {} } = response;
    if (is_success) {
      dispatch(setFaqList(data));
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const getFaq = (id) => async (dispatch) => {
  try {
    const response = await api.get(apiEndPoints.getFaq(id));
    const { data: { is_success, faq } = {} } = response;
    if (is_success) {
      return faq;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const addFaq = (payload) => async (dispatch) => {
  try {
    const response = await api.post(apiEndPoints.createFaqs, payload);
    const { data: { is_success, message } = {} } = response;
    if (is_success) {
      dispatch(
        showSnackbar({
          message: message,
          type: snackbarTypes.SUCCESS,
        })
      );
      return true;
    }
    dispatch(
      showSnackbar({
        message: message,
        type: snackbarTypes.ERROR,
      })
    );
    return false;
  } catch (error) {
    return false;
  }
};

export const editFaq = (payload, id) => async (dispatch) => {
  try {
    const response = await api.put(apiEndPoints.updateFaqs(id), payload);
    const { data: { is_success, message } = {} } = response;
    if (is_success) {
      dispatch(
        showSnackbar({
          message: message,
          type: snackbarTypes.SUCCESS,
        })
      );
      return true;
    }
    dispatch(
      showSnackbar({
        message: message,
        type: snackbarTypes.ERROR,
      })
    );
    return false;
  } catch (error) {
    return false;
  }
};

export const deleteFaq = (id) => async (dispatch) => {
  try {
    const response = await api.delete(apiEndPoints.deleteFaqs(id));
    const { data: { is_success, message } = {} } = response;
    if (is_success) {
      dispatch(
        showSnackbar({
          message: message,
          type: snackbarTypes.SUCCESS,
        })
      );
      return true;
    }
    dispatch(
      showSnackbar({
        message: message,
        type: snackbarTypes.ERROR,
      })
    );
    return false;
  } catch (error) {
    return false;
  }
};
